export enum Role {
  Admin = 'admin',
  Candidate = 'candidate',
  Employer = 'employer'
}
